import {useState,useEffect} from 'react';
import {db,supabase} from '../config/supabase';

export const useSupabaseAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Get initial session
    const initializeAuth = async () => {
      try {
        const {data: {session}} = await supabase.auth.getSession();
        if (session?.user) {
          // Get user profile from users table
          const {data: userProfile} = await db.getUserById(session.user.id);
          setUser(userProfile);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();

    // Listen for auth changes
    const {data: {subscription}} = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (event === 'SIGNED_IN' && session?.user) {
          const {data: userProfile} = await db.getUserById(session.user.id);
          setUser(userProfile);
        } else if (event === 'SIGNED_OUT') {
          setUser(null);
        }
        setLoading(false);
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  const signIn = async (username, password, role) => {
    setLoading(true);
    setError(null);
    try {
      console.log('Attempting login:', {username, role, passwordLength: password.length});

      // Special case for admin login - check database directly
      if (username === 'admin' && password === '^h$W_J18xpE0SsL' && role === 'admin') {
        console.log('Admin login detected, checking database...');
        
        // Simple query for admin user (RLS is disabled)
        const {data: adminUsers, error: adminError} = await supabase
          .from('users')
          .select('*')
          .eq('username', 'admin')
          .eq('role', 'admin');

        if (adminError) {
          console.error('Error getting admin user:', adminError);
          throw new Error('Admin user not found or database error');
        }

        if (adminUsers && adminUsers.length > 0) {
          console.log('Admin user found, setting user...');
          setUser(adminUsers[0]);
          return {success: true};
        }

        throw new Error('Admin user not found in database');
      }

      // For other users, check if user exists in our users table
      const {data: users} = await db.getUsers();
      const foundUser = users.find(u => u.username === username && u.role === role);

      if (foundUser) {
        // Verify password (simple check for demo)
        const isValidPassword = atob(foundUser.password_hash) === password;
        if (isValidPassword) {
          setUser(foundUser);
          return {success: true};
        } else {
          throw new Error('Password errata');
        }
      } else {
        throw new Error('Utente non trovato');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message);
      return {success: false, error: err.message};
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    setLoading(true);
    try {
      await supabase.auth.signOut();
      setUser(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    user,
    loading,
    error,
    signIn,
    signOut
  };
};